<span class="p-float-label">
    <p-dropdown [showClear]="true" id="group" [options]="companyGroups" [(ngModel)]="selectedGroup"
        [autoDisplayFirst]="false" optionLabel="name" optionValue="name" [filter]="true"></p-dropdown>
    <label>{{ 'GENERAL.GROUP' | translate }}</label>
</span>